// React for Website

import React from "react";
//outsource
import { Form, Input } from "antd";

//components

const StaffIRD = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="ird"
      initialValue={""}
      rules={[
        {
          max: 9,
          message: "Max length 9 numbers",
        },
        {
          pattern: /^[0-9]+$/,
          message: "Accept number only",
        },
      ]}
    >
      <Input
        style={{ width: 200 }}
        placeholder="Input IRD number"
        disabled={disabled}
        showCount
        maxLength={9}
      />
    </Form.Item>
  );
};

export default StaffIRD;
